import { create } from "@bufbuild/protobuf";
import { ClientEnvelopeSchema, Role } from "../gen/game/v1/envelope_pb";

const WIRE_VERSION = 1;

export type ClientCommand =
  | ReturnType<typeof helloCommand>
  | ReturnType<typeof createRoomCommand>
  | ReturnType<typeof joinRoomCommand>
  | ReturnType<typeof leaveRoomCommand>
  | ReturnType<typeof startGameCommand>
  | ReturnType<typeof loadedCommand>
  | ReturnType<typeof skipTutorialCommand>
  | ReturnType<typeof continueAfterMatchCommand>
  | ReturnType<typeof dealerTurnCommand>
  | ReturnType<typeof playerTurnCommand>
  | ReturnType<typeof playerVoteCommand>
  | ReturnType<typeof changeAvatarCommand>
  | ReturnType<typeof resumeCommand>;

export function helloCommand(seq: bigint, role: Role, name = "") {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "hello",
      value: { role, name },
    },
  });
}

export function createRoomCommand(seq: bigint) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "createRoom",
      value: {},
    },
  });
}

export function joinRoomCommand(seq: bigint, code: string, name: string) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "joinRoom",
      value: { code, name },
    },
  });
}

export function leaveRoomCommand(seq: bigint) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "leaveRoom",
      value: {},
    },
  });
}

export function startGameCommand(seq: bigint) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "startGame",
      value: {},
    },
  });
}

export function loadedCommand(seq: bigint) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "loaded",
      value: {},
    },
  });
}

export function skipTutorialCommand(seq: bigint) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "skipTutorial",
      value: {},
    },
  });
}

export function continueAfterMatchCommand(seq: bigint) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "continueAfterMatch",
      value: {},
    },
  });
}

export function dealerTurnCommand(seq: bigint, cardId: string, phrase: string) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "dealerTurn",
      value: { cardId, phrase },
    },
  });
}

export function playerTurnCommand(seq: bigint, cardId: string) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "playerTurn",
      value: { cardId },
    },
  });
}

export function playerVoteCommand(seq: bigint, voteCardId: string) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "playerVote",
      value: { voteCardId },
    },
  });
}

export function changeAvatarCommand(seq: bigint, avatarId: string) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "changeAvatar",
      value: { avatarId },
    },
  });
}

export function resumeCommand(
  seq: bigint,
  role: Role,
  roomCode: string,
  playerId: string,
  sessionToken: string,
) {
  return create(ClientEnvelopeSchema, {
    v: WIRE_VERSION,
    seq,
    body: {
      case: "resume",
      value: { role, roomCode, playerId, sessionToken },
    },
  });
}
